import router from 'next/router';
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { isMobile as isMobileDetect } from 'react-device-detect';
import { allDataHomePage } from '../../services/home';
import { apenasNumeros, formatSelects } from '../../utils/FunctionsGlobals';
import { setWithTTL } from '../../utils/storage';

/*
 * ---------------------------------------------------------------
 * TIPAGEM
 * ---------------------------------------------------------------
 */

interface AuthData {
  site: {
    fb_token_pixel: string;
    top_10: boolean;
    redes_topo: boolean;
    fb_id_pixel: string;
    ocultar_endereco: boolean;
    copyright: boolean;
    titulo_automatico: boolean;
    modelo_pagina_imovel: number;
    modelo_topo: number;
    modelo_cidades: number;
    modelo_busca: number;
    modelo_card: number;
    modelo_depoimento: number;
    modelo_selection: number;
    modelo_empresa: number;
    modelo_blogs: number;
    modelo_redes: number;
    modelo_fundo: number;
    modelo_pesquisa_popular: number;
    modelo_equipe: number;
    cards_busca: boolean;
    mostrar_data_entrega: boolean;
    afiliado_todo_site: boolean;
    categoria_home: boolean;
    caracteristicas_home: boolean;
    titulo_card_1: string;
    titulo_card_2: string;
    titulo_card_3: string;
    texto_card_1: string;
    texto_card_2: string;
    texto_card_3: string;
    depoimento_imovel: boolean;
    ver_url: boolean;
    banner_imovel: boolean;
    cidade_priorizada: string;
    texto_botao_whats?: string | null;
    formulario_whats: boolean;
    mostrar_mapa: boolean;
    exibir_empreendimento: boolean;
    moeda_tipo: string;
    simulador: boolean;
    ativa_logs: boolean;
    casa_em_condominio: boolean;
    carousel_temporada: boolean;
    carousel_apartamento: boolean;
    carousel_lancamentos: boolean;
    exibir_cidade_bairro_no_imovel: boolean;
    carousel_casa: boolean;
    carousel_novidades: boolean;
    titulo_c_top: string;
    titulo_c_temporada: string;
    titulo_c_novidades: string;
    titulo_c_casas: string;
    titulo_c_1: string;
    titulo_c_2: string;
    titulo_c_c_condominio: string;
    titulo_c_apartamentos: string;
    id: number;
    modelo_novo: string;
    ordenar_lista: string;
    mostrar_visualizacoes: boolean;
    site: string;
    titulo: string;
    meta_keywords: string;
    meta_description: string;
    url_logo: string;
    url_icon: string;
    url_video: string;
    rodape: number;
    texto_rodape: string;
    cor1: string;
    cor2: string;
    cor3: string;
    cor4: string;
    cor5: string;
    cor6: string;
    cor7: string;
    cor8: string;
    cor9: string;
    cor10: string;
    cor11: string;
    cor12: string;
    cor13: string;
    cor14: string;
    cor15: string;
    vgv_total: string
    total_imoveis: number
    total_cidades: number
    exibe_redes_sociais: boolean;
    congelado: boolean;
    qtd_fotos_bloqueios: number;
    bloquear_fotos: number;
    pixel_facebook_head: string;
    link_chat_body: string;
    link_chat_head: string;
    tag_google_head: string;
    tag_google_body: string;
    google_analytics_body: string;
    google_analytics_head: string;
    libera_fts_aluguel: string;
    banner_home?: string | null;
    carrossel_corretores: string;
    frase_busca: string;
    frase_busca_2: string;
    tamanho_logo: number;
    logo_horizontal: boolean;
    navbar_transparente: boolean;
    transacoes: string[];
    politica_privacidade: string;
    termos_uso: string;
    promocao: boolean;
    Dados: {
      inicio_txt_descricao: string;
      delegar_ao_agenciador?: boolean | null;
      horario: string;
      final_txt_descricao: string;
      empresa: string;
      email1: string;
      email2: string;
      email3?: string | null;
      email4?: string | null;
      tel1: string;
      tel2: string;
      tel3: string;
      tel4: string;
      tel1_nome: string;
      tel2_nome: string;
      tel3_nome: string;
      tel4_nome: string;
      tel1_whats: boolean;
      tel2_whats: boolean;
      tel3_whats: boolean;
      tel4_whats: boolean;
      endereco: string;
      cidade: string;
      bairro: string;
      creci: string;
      youtube: string;
      facebook: string;
      twitter: string;
      instagram: string;
      threads: string;
      tiktok: string;
    };
    video: boolean;
    widget_youtube: string;
    widget_instagram: string;
    marca_dagua: {
      ativada: number;
    };
    exibir_agenciador: boolean;
  };
  videos: {
    url_youtube: string;
    excluido: boolean;
  }[];
   blogs: {
      id: number;
      url_foto: string;
      autor: string;
      titulo: string;
      texto: string;
      excluido: boolean;
      data_cadastro: string;
      id_cidade: number;
      id_empreendimento: number;
      categoria: string;
      id_categoria: number;
  }[];
  rodape: {
    tipo: string;
    cidade: string;
    bairro: string;
    dormitorios: string | null;
    aluguel: number;
    venda: number;
    empreendimento?: string | null;
  }[];
  allBanners: {
    id: number;
    codsite: number;
    exibir: string;
    ordem: number;
    extensao: string;
    titulo: string;
    url: string;
    url_link: string;
    message: string;
    ativo: boolean;
  }[];
  banner_empresa?: {
    linkbanner: string;
    card_titulo: string;
    subtitulo_1: string;
    paragrafo_1: string;
    subtitulo_2: string;
    paragrafo_2: string;
    subtitulo_3: string;
    paragrafo_3: string;
    corconfig: string;
  } | null;
  menus: {
    link: string;
    titulo: string;
    Destino: string;
    Disponivel: number;
    Menu: number;
    Rodape: number;
    Topo: number;
    Conteudo: string;
  }[];
  cidades: {
    id: number;
    nome: string;
    id_estado: number;
    url_foto: string;
  }[];
  tipos: {
    id: number;
    nome: string;
  }[];
  redes_sociais: {
      nome: string
      href: string
      imagem: string
      seguidores: string
      arroba: string
  }[];
  parceiros: {
    id: number;
    nome: string;
    telefone: string;
    telefone_2?: string | null;
    email: string;
    mostrar_equipe: boolean;
    descricao?: string | null;
    funcao: {
      id: number;
      nome: string;
    } | null;
    url_foto: string;
    creci: string;
    link_proprio?: string | null;
    linkedin?: string | null;
    instagram?: string | null;
    facebook?: string | null;
  }[];
  depoimentos: {
    depoimento: string;
    youtube: string;
    cliente: {
      nome: string;
      foto?: string | null;
    };
  }[];
  precos_locacao: {
    min: number;
    max: number;
  }[];
  precos_venda: {
    min: number;
    max: number;
  }[];
  carrosseis: {
    id: number;
    id_bairro: number;
    id_tipo: number;
    id_categoria: number;
    id_cidade: number;
    id_caracteristica: number;
    id_empreendimento: number;
    preco_min: number;
    preco_max: number;
    titulo: String;
    top_10: Boolean;
    url_red: String;
    novidades_semana: Boolean;
    personalizado: Boolean;
    exclusivos: Boolean;
    venda: Boolean;
    aluguel: Boolean;
    cor_fundo: String;
    cor_degrade: String;
    cor_font: String;
    cor_botoes: String;
  }[];
}

export interface AuthContextType {
  allDataHome: AuthData | null;
  init_props: any;
  favorito: any;
  allViewProperties: any;
  allCompany: any;
  isMobile1: boolean;
  setFavorito: (_favs: any[]) => void;
  setAllViewProperties: (_value: any[]) => void;
  setAllCompany: (_value: any) => void;
  allCarrosseis: any;
  setAllCarrosseis: (_value: any) => void;
  setGetOnlyQuery1: (_value: any) => void;
  listCategory: any;
  getOnlyQuery1: any;
  setListCategory: (_value: any) => void;
  listEstados: any;
  setListEstados: (_value: any) => void;
  listCaracteristicas: any;
  setListCaracteristicas: (_value: any) => void;
  listDatas: any;
  setListDatas: (_value: any) => void;
  include_favorito: (_imovel: any) => void;
  include_visualizado: (_imovel: any) => void;
  delete_favorito: (_imovel: any) => void;
  setUltimaConsulta: (_value: any) => void;
  ultimaConsulta: any;
  politic: null | 'accepted' | 'rejected' | 'nao';
  setPolitic: (_value: null | 'accepted' | 'rejected' | 'nao') => void;
}

/* ---------- CONTEXTO ---------- */
const AuthContext = createContext<AuthContextType | undefined>(undefined);

/* ---------- PROVIDER ---------- */
export const AuthProvider = ({
  children,
  init_props,
  allDataHome: allDataHomeProp,
}: Partial<AuthContextType> & { children: ReactNode }) => {
    const [favorito, setFavorito] = useState<Array<number>>([]);
    const [allViewProperties, setAllViewProperties] = useState<Array<number>>([]);
    const isMobile1 = init_props?.isMobile || isMobileDetect;

    const [allCompany, setAllCompany] = useState(
        init_props?.all_company?.empreendimentos
        ? formatSelects(init_props?.all_company?.empreendimentos)
        : []
    );
    const [allCarrosseis, setAllCarrosseis] = useState(
        init_props?.all_carrosseis || []
    );
    const [getOnlyQuery1, setGetOnlyQuery1] = useState<any[]>([]);
    const [listCategory, setListCategory] = useState<any>(0);
    const [listEstados, setListEstados] = useState<any>(0);
    const [listCaracteristicas, setListCaracteristicas] = useState<any>(0);
    const [listDatas, setListDatas] = useState<any>(0);
    const [ultimaConsulta, setUltimaConsulta] = useState<any>('');
    const TTL = 60 * 60 * 1000 * 2; // 2 horas
    const TTL1 = 60 * 30 * 1000; // 1 horas
    const [politic, setPoliticState] = useState<null | 'accepted' | 'rejected' | 'nao'>(null);
    
    // Carrega o consentimento do localStorage quando o app inicia
    useEffect(() => {
        const getStorage = localStorage.getItem('politic');
        if (getStorage === 'accepted') setPoliticState('accepted');
        else if (getStorage === 'rejected') setPoliticState('rejected');
        else setPoliticState('nao');
        if(allCarrosseis?.length > 0){
          setWithTTL(`all_carrosseis:${allDataHome?.carrosseis?.length}`, allCarrosseis, TTL1);
        }
        const { favoritos } = router.query;
        if(favoritos){
            setFavorito(favoritos ? apenasNumeros(favoritos) : [])
        } else {
          const saved = localStorage.getItem('favoritos');
          if (saved) {
              setFavorito(JSON.parse(saved));
          }
        }
        const saved = localStorage.getItem('allViewProperties');
        if (saved) {
            setAllViewProperties(JSON.parse(saved));
        }
    }, []);

    // Salva no localStorage sempre que o usuário aceitar ou rejeitar
    const setPolitic = (_value: null | 'accepted' | 'rejected' | 'nao') => {
        setPoliticState(_value);
        if (_value) localStorage.setItem('politic', _value);
    };

    /* --------------------------------------------------
    * FAVORITOS
    * -------------------------------------------------- */
    useEffect(() => {
        if (favorito.length === 0) {
              localStorage.removeItem('favoritos');
        } else {
          localStorage.setItem('favoritos', JSON.stringify(favorito));
        }
    }, [favorito]);

    useEffect(() => {
        if (allViewProperties?.length == 0) {
          localStorage.removeItem('allViewProperties');
        } else {
          localStorage.setItem('allViewProperties', JSON.stringify(allViewProperties));
        }
    }, [allViewProperties]);

    /* --------------------------------------------------
    * ÚLTIMA CONSULTA + TTL
    * -------------------------------------------------- */
    useEffect(() => {
        if (ultimaConsulta) {
          setWithTTL(`ultima_consulta:${ultimaConsulta}`, getOnlyQuery1, TTL);
          localStorage.setItem('url_ultima_consulta', JSON.stringify(ultimaConsulta));
        } else {
          const ultima = localStorage.getItem('url_ultima_consulta');
          if (ultima) {
              const ultimaProp = localStorage.getItem(`ultima_consulta:${JSON.parse(ultima)}`);
              if (ultimaProp) setUltimaConsulta(JSON.parse(ultima));
              else localStorage.removeItem('url_ultima_consulta');
          }
        }
    }, [TTL, ultimaConsulta, getOnlyQuery1]);

    /* --------------------------------------------------
    * FUNÇÃO PARA BUSCAR DADOS DO SITE
    * -------------------------------------------------- */
    const getInfoSite = useCallback(async () => {
        const cached = localStorage.getItem('allDataHome');
        if (cached) {
        setAllDataHome(JSON.parse(cached));
        return;
        }
        const fetched = await allDataHomePage(init_props?.prodOrigin, init_props?.codsite);
        if (fetched) {
        localStorage.setItem('allDataHome', JSON.stringify(fetched));
        setAllDataHome(fetched);
        }
    }, [init_props?.prodOrigin, init_props?.codsite]);

    const [allDataHome, setAllDataHome] = useState<AuthData | null>(allDataHomeProp || null);

    /* --------------------------------------------------
    * CARREGA CONDOMÍNIOS / ALLDATAHOME
    * -------------------------------------------------- */
    useEffect(() => {
        if (allCompany.length === 0 && allDataHome?.site.exibir_empreendimento) {
        const timeout = setTimeout(() => {
            const cached = JSON.parse(localStorage.getItem('condominios') || '[]');
            if (cached?.empreendimentos?.length > 0) {
            setAllCompany(formatSelects(cached.empreendimentos));
            }
        }, 1000);
        return () => clearTimeout(timeout);
        } else if (allCompany.length > 0) {
        localStorage.setItem('condominios', JSON.stringify(allCompany));
        }

        if (allDataHome) localStorage.setItem('allDataHome', JSON.stringify(allDataHome));
        else getInfoSite();
    }, [allCompany, allDataHome, getInfoSite]);

    /* --------------------------------------------------
    * FUNÇÕES DE FAVORITOS
    * -------------------------------------------------- */
    const include_favorito = useCallback((_imovel: any) => {
        setFavorito((prev) => prev.concat(_imovel));
    }, []);

    const include_visualizado = useCallback((_imovel: any) => {
      if(_imovel)
        setAllViewProperties((prev) => prev.concat(_imovel));
    }, []);

    const delete_favorito = useCallback((_imovel: any) => {
      setFavorito((prev) => {
        if(prev?.length <= 1)
          return [];
        else
          return prev.filter((id) => id !== _imovel);
      });
    }, []);

    /* --------------------------------------------------
    * CONTEXTO MEMOIZADO
    * -------------------------------------------------- */
    const ctxValue = useMemo<AuthContextType>(
        () => ({
            init_props: init_props || null,
            allDataHome: allDataHome || null,
            favorito,
            setAllViewProperties,
            allViewProperties,
            listCategory,
            ultimaConsulta,
            setListCategory,
            setUltimaConsulta,
            listEstados,
            setListEstados,
            listCaracteristicas,
            setListCaracteristicas,
            listDatas,
            setListDatas,
            setAllCarrosseis,
            allCarrosseis,
            setGetOnlyQuery1,
            getOnlyQuery1,
            allCompany,
            isMobile1,
            setFavorito,
            setAllCompany,
            delete_favorito,
            include_favorito,
            include_visualizado,
            politic,
            setPolitic
          }),
        [
            ultimaConsulta,
            setUltimaConsulta,
            init_props,
            isMobile1,
            setAllViewProperties,
            allViewProperties,
            allDataHome,
            allCompany,
            favorito,
            listCategory,
            setListCategory,
            listEstados,
            setListEstados,
            listCaracteristicas,
            setListCaracteristicas,
            listDatas,
            setListDatas,
            allCarrosseis,
            setAllCarrosseis,
            getOnlyQuery1,
            setGetOnlyQuery1,
            setFavorito,
            setAllCompany,
            delete_favorito,
            include_favorito,
            include_visualizado,
            politic,
            setPolitic
        ]
    );

  return <AuthContext.Provider value={ctxValue}>{children}</AuthContext.Provider>;
};

export const useAuth = (): AuthContextType => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
};